import axios from "axios";
import BB from "bluebird";

export default {
	/**
	 * @returns {Promise} of "Pages" that can be rendered
	 * @param {*} response
	 */
	setupResponse(response) {
		var _this = this;
		//For backwards compatibility we'll convert top-level text/pdf responses into a media object
		if (response.media && response.media.length) {
			//Normal path
		} else {
			response.media = [
				{
					sequence: 1,
					value: response.text,
					signed_url: response.signed_url,
					mime_type: response.mime_type,
					label: response.label
				}
			];
			response.back_combatable = true;
		}

		var media = _.sortBy(response.media, m => {
			return m.sequence;
		});

		var promises = [];
		_.each(media, m => {
			promises.push(_this.setupResponseMedia(m));
		});

		return new Promise(function (resolve, reject) {
			Promise.all(promises).then(function (results) {
				resolve(_.flatten(results));
			});
		});
	},

	responseHasMedia(classID, assessmentID, deliveryID, itemID, studentID) {
		let cid = classID;
		let aid = assessmentID;
		let did = deliveryID;
		let iid = itemID;
		let sid = studentID;
		return axios.get(
			`/v3/response_has_media/${cid}/${aid}/${did}/${iid}/${sid}`
		);
	},

	addMedia(classID, assessmentID, deliveryID, itemID, form) {
		let cid = classID;
		let aid = assessmentID;
		let did = deliveryID;
		let iid = itemID;
		console.log("date is :",classID, assessmentID, deliveryID, itemID)
		return axios.post(
			`/v3/response_media/${cid}/${aid}/${did}/${iid}`,
			form
		);
	},

	addGDriveMedia(
		classID,
		assessmentID,
		deliveryID,
		itemID,
		gapi,
		file,
		studentIDs
	) {
		let cid = classID;
		let aid = assessmentID;
		let did = deliveryID;
		let iid = itemID;

		let req = {
			name: file.name,
			mime_type: file.mimeType,
			id: file.id,
			token: gapi.client.getToken(),
			student_ids: studentIDs
		};

		return axios.post(`/v3/gdrive_media/${cid}/${aid}/${did}/${iid}`, req);
	},

	addGDriveMediaExternal(
		classID,
		assessmentID,
		deliveryID,
		itemID,
		gapi,
		file,
		studentIDs,
		reqStudentID
	) {
		let cid = classID;
		let aid = assessmentID;
		let did = deliveryID;
		let iid = itemID;

		let req = {
			name: file.name,
			mime_type: file.mimeType,
			id: file.id,
			token: gapi.client.getToken(),
			student_ids: studentIDs
		};

		return axios.post(
			`/v3/external/gdrive_media/${cid}/${aid}/${did}/${iid}/${reqStudentID}`,
			req
		);
	},

	removeMedia(responseID, sequence) {
		return axios.delete(`/v3/response_media/${responseID}/${sequence}`);
	},

	getMedia(clazz, assessment, delivery, item) {
		return axios.get(
			`/v3/response_media/${clazz}/${assessment}/${delivery}/${item}`
		);
	},

	updateMedia(datas, clazz, assessment, delivery, item) {
		return axios.post(
			`/v3/response_media_update/${clazz}/${assessment}/${delivery}/${item}`,datas
		);
	},

	setupExemplar(path) {
		if (path.startsWith("https://vimeo.com")) {
			let parts = path.split("/");

			let media = {
				signed_url: path,
				vimeo_id: parts[parts.length - 1],
				mime_type: "video/vimeo"
			};

			return this.setupResponseMedia(media);
		} else {
			return axios
				.get(`/v3/mime_type`, { params: { url: path } })
				.then(resp => {
					let media = {
						signed_url: path,
						mime_type: resp.data
					};

					return this.setupResponseMedia(media);
				});
		}
	},

	setupResource(resource, item) {
		//Have to get the signed url first
		if (resource.type == 1) {
			//Internally stored document
			var request = axios.get(
				`/v3/resource_url/${item.assessment_id}/${resource.id}`
			);
			return request.then(resp => {
				//Set up the resource so it looks like a response media, then it can be processed the same way
				let media = {
					sequence: 1,
					signed_url: resp.data,
					mime_type: resource.mime_type
				};
				console.log("Load resource", media);
				return this.setupResponseMedia(media);
			});
		} else if (resource.type == 4) {
			//External link
			//Set up the resource so it looks like a response media, then it can be processed the same way
			let media = {
				sequence: 1,
				signed_url: resource.path,
				mime_type: resource.mime_type,
				body:resource.body
			};
			console.log("Load resource", media);
			return this.setupResponseMedia(media);
		} else if (resource.type == 2) {
			//External link
			//Set up the resource so it looks like a response media, then it can be processed the same way
			let media = {
				sequence: 1,
				signed_url: resource.path,
				mime_type: resource.mime_type
			};
			console.log("Load resource", media);
			return this.setupResponseMedia(media);
		}
	},

	setupResponseMedia(medias) {
		if (!medias.length) {
			medias = [medias];
		}
		return new Promise((resolve, reject) => {
			var pages = [];
			var pdfRendered = {};
			function maybeResolve() {
				if (_.every(pdfRendered)) {
					resolve(pages);
				}
			}

			_.each(medias, (media, j) => {
				if (media.mime_type == "application/pdf") {
					// pdfjsLib.disableWorker = true;
					pdfRendered[j] = false;

					var now = new Date().getTime();
					pdfjsLib
						.getDocument(media.signed_url)
						.then(function (pdf) {
							console.log(
								"GetPDF:" + (new Date().getTime() - now)
							);
							var numPages = pdf.pdfInfo.numPages;
							var loaded = 0;
							for (var i = 1; i <= numPages; i++) {
								var idx = i;
								pdf.getPage(i).then(function (page) {
									var p = {
										type: "pdf",
										pdf: page,
										label: media.label,
										index: page.pageNumber,
										media_index: media.sequence,
										title: media.title
									};

									pages.push(p);

									loaded++;
									if (loaded == numPages) {
										pdfRendered[j] = true;
										maybeResolve();
									}
								});
							}
						})
						.catch(function (e) {
							reject(e);
						});
				} else if (_.endsWith(media.mime_type, "text")) {
					pages.push({
						type: "text",
						text: media.value,
						label: media.label,
						media_index: media.sequence,
						title: media.title,
						preventRenderHTML: media.nts
					});
				} else if (_.endsWith(media.mime_type, "html")) {
					pages.push({
						type: "html",
						text: media.body,
						media_index: media.sequence,
						title: media.name,
						preventRenderHTML: media.nts
					});
				} else if (_.startsWith(media.mime_type, "video")) {
					let page = {
						type: "video",
						text: media.value,
						url: media.signed_url,
						label: media.label,
						title: media.title
					};
					if (media.mime_type == "video/vimeo") {
						page.vimeo = true;
						page.vimeo_embed = `https://player.vimeo.com/video/${media.vimeo_id}`;
					}
					pages.push(page);
				} else if (_.startsWith(media.mime_type, "audio")) {
					pages.push({
						type: "audio",
						text: media.value,
						url: media.signed_url,
						label: media.label,
						title: media.title
					});
				} else if (_.startsWith(media.mime_type, "image")) {
					pages.push({
						type: "image",
						text: media.value,
						url: media.signed_url,
						label: media.label,
						media_index: media.sequence,
						title: media.title
					});
					console.log(pages);
				} else {
					pages.push({ blank: true });
				}
			});
			if (_.every(pdfRendered)) {
				resolve(pages);
			}
		});
	}
};



// WEBPACK FOOTER //
// ./src/services/ResponseMediaService.js